var _module = require('../../components/module');

require('angular-ui-bootstrap/src/modal');
require('../lr-touch');

_module.requires.push('ui.bootstrap.module.modal');

_module.service('$buyerInterestedModal', [
    '$log',
    '$uibModal',

    function $buyerInterestedModal($log, $uibModal) {
        return function openBuyerInterestedModal(profiles, options) {
            options = options || {};
            var modal = $uibModal.open({
                animation: false,
                template: require('./index.html'),
                controller: [
                    '$scope',

                    function BuyerInterestedModalCtrl($scope) {
                        $scope.bim = {
                            model: {
                                profiles: profiles
                            }
                        };
                    }
                ],
                backdrop: true,
                windowClass: 'buyer-interested-modal'
            });

            return modal;
        };
    }
]);
